module.exports = __webpack_public_path__ + "tausta_vas.f506ddc55b8f719fe49a.jpg";


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/src/assets/img/tausta_vas.jpg
// module id = ../../../../../src/assets/img/tausta_vas.jpg
// module chunks = 2